import { FC } from "react";
import { Outlet } from "react-router";
import { isMobile } from "react-device-detect";
import AboutNavigation from "./components/AboutNavigation";
import { Helmet } from "react-helmet-async";

const AboutPage: FC = () => {
  return (
    <div className={`flex ${isMobile ? "flex-col p-2" : "flex-row p-4 gap-4"}`}>
      <Helmet>
        <>
          <title>КЦ Авто | О нас</title>
          <meta
            name="description"
            content={`КЦ авто о компании о нас политика конфилициальности купить автозапчасти Корея центр`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти, о компании, о нас, политика конфилициальности, доставка и оплата"
          />
        </>
      </Helmet>
      <AboutNavigation />
      <div className={`${isMobile ? "px-2" : ""} flex-1`}>
        <Outlet />
      </div>
    </div>
  );
};

export default AboutPage;
